module.exports = __webpack_public_path__ + "static/assets/8f160ba31754d0e965eaeb54b60d6240.svg";